import {
  removeDiacritics,
  removeStopWords,
  replaceMultipleDashes,
  replaceSlashesAndSpaces,
  replaceSpecialCharactersButNotHyphenOrSpace,
  trimDashes,
} from '../string/replacements';

/**
 * Takes an input string, removes diacritics, replaces slashes and spaces with
 * dashes, replaces special characters, trims dashes, and returns a formatted slug in lowercase.
 * @param {string} inputString - The `inputString` parameter is a string that represents the input text
 * that needs to be converted into a slug.
 * @returns a formatted slug string in lowercase.
 */
export const slugify = (inputString: string | undefined | null): string => {
  if (!inputString || !inputString.trim()) {
    return '';
  }

  // The order in which the functions are called matters here, please make sure to thoroughly test
  // and add unit tests should you make any changes to the order of the functions / or add new functions.

  const trimmedString = removeDiacritics(inputString.trim());
  const dashedString = replaceSlashesAndSpaces(trimmedString);
  const noSpecialCharactersString =
    replaceSpecialCharactersButNotHyphenOrSpace(dashedString);

  const slugAfterStopWordsAreRemoved = removeStopWords(
    noSpecialCharactersString
  );
  const formattedSlug = trimDashes(
    replaceMultipleDashes(slugAfterStopWordsAreRemoved)
  );

  return formattedSlug.toLowerCase();
};
